import React from "react";
import styles from "./MHCarousel.module.css";
import { useSwipeable } from "react-swipeable";

function MHCarousel({ children, itemcount, selectedIndex,setSelectedIndex }) {
  const nextItem = () => {
    setSelectedIndex(
      selectedIndex === itemcount - 1 ? 0 : selectedIndex + 1,
    );
  };

  const previousItem = () => {
    setSelectedIndex(
      selectedIndex === 0 ? itemcount - 1 : selectedIndex - 1,
    );
  };

  const handlers = useSwipeable({
    onSwipedLeft: nextItem,
    onSwipedRight: previousItem,
  });

  return (
    <div {...handlers} className={styles.SwipeableContainer}>
      <div className={styles.CarouseContent}>{children}</div>
    </div>
  );
}

export default MHCarousel;
